// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"GamePage_sideBar__3ET7r","miniMap":"GamePage_miniMap__1rzK3"};